import axios from 'axios';

import traceId from 'redux/traceId';

export const getUniversalJusfinderStatus = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/v2/universal-jusfinder/status`,
    { headers: { 'x-trace-id': traceId } },
  );

  return response.data;
};
